var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',{staticClass:"my-3"},[_c('b-col',[_c('h4',{staticClass:"text-center text-primary"},[_c('i',{staticClass:"fa fa-bar-chart text-primary mr-2"}),_vm._v("\n               Búsquedas Contable\n            ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }